import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
    ArrowUpToLine,
    ArrowDownToLine,
    ArrowLeftToLine,
    ArrowRightToLine,
    Rows3,
    Columns3,
    Trash2,
} from "lucide-react";
import MenuItem from "../../../modals/MenuItem";

interface TableActionsProps {
    onInsertRowAbove: () => void;
    onInsertRowBelow: () => void;
    onInsertColumnLeft: () => void;
    onInsertColumnRight: () => void;
    onDeleteRow: () => void;
    onDeleteColumn: () => void;
    onDeleteTable: () => void;
}

const ICON_SIZE = 15;
const DANGER_ITEM_CLASSNAME = "text-red-500 hover:bg-red-100 hover:dark:bg-dark-bg-600";

// Contextual menu shown when the cursor is inside an existing table.
// Only exposes user-facing labels; the underlying Quill table module methods stay hidden.
const TableActions: FC<TableActionsProps> = ({
    onInsertRowAbove,
    onInsertRowBelow,
    onInsertColumnLeft,
    onInsertColumnRight,
    onDeleteRow,
    onDeleteColumn,
    onDeleteTable,
}) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col min-w-[200px]">
            <MenuItem onClick={onInsertRowAbove}>
                <div className="flex items-center gap-2">
                    <ArrowUpToLine size={ICON_SIZE} /> {t("richTextEditor.insertRowAbove")}
                </div>
            </MenuItem>
            <MenuItem onClick={onInsertRowBelow}>
                <div className="flex items-center gap-2">
                    <ArrowDownToLine size={ICON_SIZE} /> {t("richTextEditor.insertRowBelow")}
                </div>
            </MenuItem>
            <MenuItem onClick={onInsertColumnLeft}>
                <div className="flex items-center gap-2">
                    <ArrowLeftToLine size={ICON_SIZE} /> {t("richTextEditor.insertColumnLeft")}
                </div>
            </MenuItem>
            <MenuItem onClick={onInsertColumnRight}>
                <div className="flex items-center gap-2">
                    <ArrowRightToLine size={ICON_SIZE} /> {t("richTextEditor.insertColumnRight")}
                </div>
            </MenuItem>
            <hr className="my-1 border-light-border-100 dark:border-dark-border-100" />
            <MenuItem onClick={onDeleteRow} className={DANGER_ITEM_CLASSNAME}>
                <div className="flex items-center gap-2">
                    <Rows3 size={ICON_SIZE} /> {t("richTextEditor.deleteRow")}
                </div>
            </MenuItem>
            <MenuItem onClick={onDeleteColumn} className={DANGER_ITEM_CLASSNAME}>
                <div className="flex items-center gap-2">
                    <Columns3 size={ICON_SIZE} /> {t("richTextEditor.deleteColumn")}
                </div>
            </MenuItem>
            <MenuItem onClick={onDeleteTable} className={DANGER_ITEM_CLASSNAME}>
                <div className="flex items-center gap-2">
                    <Trash2 size={ICON_SIZE} /> {t("richTextEditor.deleteTable")}
                </div>
            </MenuItem>
        </div>
    );
};

export default TableActions;
